import React from 'react';
import PropTypes from 'prop-types';

import Slider from '@Components/Slider';

import './RsSlider.theme.scss';

// Taken from RetroSynthesisTimeSlider with some changes to make it reusable

function RsSlider({ min, max, step, labelFunction, value, onChange, ariaLabel }) {
  return (
    <div className="rs-slider">
      <Slider
        ariaLabel={ariaLabel}
        step={step}
        onChange={onChange}
        value={value}
        min={min}
        max={max}
        showTooltip
        labelFunction={labelFunction}
      />
      <div className="rs-slider__time-box">
        <div className="rs-slider__mark rs-slider__time-box-min">{labelFunction(min)}</div>
        <div className="rs-slider__mark rs-slider__time-box-max">{labelFunction(max)}</div>
      </div>
    </div>
  );
}

export default RsSlider;

RsSlider.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  labelFunction: (value) => `${Math.round(value)}%`,
  onChange: () => null,
};

RsSlider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  labelFunction: PropTypes.func,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  ariaLabel: PropTypes.string,
};
